<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="250px">

        <!-- 第四步 -->
        <div>
            <el-form-item label="作品名称" prop="subject">
            <el-input placeholder="请输入作品名称" v-model="form.subject"></el-input>
            </el-form-item>
            <el-form-item
            label="上传作品"
            ref="uploader"
            class="uploadWraper"
            prop="files"
            >
            <el-upload
                class="commonUpload"
                drag
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="uploadSuccess"
                :on-remove="(file, fileList) => {handleRemove(file, fileList)}"
                :before-upload="uploadBefore"
                :limit="5"
                :on-exceed="handleExceed"
                multiple
                :file-list="fileList"
            >
                <div class="commonUploadInner">
                <i class="iconfont iconUpload">&#xe606;</i>
                <div class="el-upload__text">
                    <div>将文件拖到此处，或<em>点击上传</em></div>
                    <div style="line-height: 20px;font-size: 12px;padding: 0 10px;color: #89909B;"> 支持格式：.jpg｜.jpeg｜.gif｜.bmp｜.png｜.doc｜.docx｜.xls｜.xlsx｜.ppt｜.pptx｜.pdf｜.txt｜.wav｜.mp4｜.wmv｜.mp3｜.psd </div>
                </div>
                </div>
            </el-upload>
            <a-alert class="tips" type="warning">
                <div slot="message">温馨提示：</div>
                <div slot="description">
<!--                 1、同一批的存证文件归属于同一标签，不支持重置；<br />
                2、支持文件批量上传，一次不能超过10个文件；<br />
                3、文件永久保全。<br />
                4、如需做版权登记，请在此处将证书及作品属性相关文件一并上传。<br />
                5、超过100M的文件，存证收费将会相应增加。 -->
                1、同一批的存证文件归属于同一标签，不支持重置；<br>
                2、默认格式:  JPG | jpg | jpeg | gif | bmp | png | doc | docx | xls | xlsx | ppt | pptx | pdf | txt | wav | mp4 | wmv | mp3 | psd <br>
                3、单文件大小: 不超过100M，一次最多上传5个， 作品名称、作品电子文件名称、作品电子文件内作品名称须保持一致。 <br>
                4、文件永久保全。 <br>
                </div>
            </a-alert>
            </el-form-item>
            <el-form-item label="办理时限" prop="processingTime">
              <el-radio-group v-model="form.extra.processingTime" @change="changeProcessingTime" :disabled="type == 'edit'">
                <el-radio label="15">15个工作日(正常)</el-radio>
                <el-radio label="5">5个工作日(加急档)</el-radio><br>
                <!-- <el-radio label="3">3个工作日(加急档)</el-radio>
                <el-radio label="1">1个工作日(加急档)</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="支付方式"
              prop="payStyle"
              class="choosePayStyle"
            >
              <el-radio-group v-model="form.paymode" @change="changePaymode" :disabled="type == 'edit'">
                <el-radio label="vip">
                  <!-- <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{
                      vipInfo ? vipInfo.registerCount : 0
                    }}次）</span
                  > -->
                  <span class="onlyText" v-if="vipInfo&&vipInfo.vipType=='C'"> 会员权益支付（当前登记次数可用
                      <span v-if="form.extra.processingTime == '15'">{{vipInfo ? vipInfo.detectCount : 0}}</span>
                      <span v-if="form.extra.processingTime == '5'">{{vipInfo ? vipInfo.registerCount : 0}}</span>
                      <span v-if="form.extra.processingTime == '3'">{{vipInfo ? vipInfo.existCount : 0}}</span>
                      <span v-if="form.extra.processingTime == '1'">{{vipInfo ? vipInfo.obtainCount : 0}}</span>
                  次）</span>
                  <span class="onlyText" v-else> 会员权益支付（当前登记次数可用{{vipInfo ? vipInfo.registerCount : 0}}次）</span>
                </el-radio>
                <el-radio label="wechat">
                  <i class="iconfont weChatColor"> &#xe64f; </i>
                  <span>微信支付</span></el-radio
                >
                <el-radio label="alipay">
                  <i class="iconfont aliPayColor"> &#xe675; </i>
                  <span>支付宝支付</span></el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="支付金额" v-if="form.paymode != 'vip'" class="payMount">
              <div>
                <em class="bigPrice"> {{ form.orderAmount ? form.orderAmount : 0 }} </em> 元
              </div>
            </el-form-item>
            <el-form-item class="submitRow">
            <el-button type="primary" @click="prev">上一步</el-button>
            <el-button type="primary" @click="next">下一步</el-button>
            </el-form-item>
            
        </div>
    </el-form>

  </div>
</template>

<script>
import { queryExistOrderItems, queryDuplicate } from "@/api/EvidenceService";
import multipleSelect from "../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../components/form/choosePersonDialog";
import resultView from "../components/resultView";
import ChinaAreaData from "@/components/ChinaAreaData";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from "../../../../mixins";
import constants from "@/utils/constants";
import request from '@/utils/request'

export default {
  name: "RegisterInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: {
    multipleSelect,
    choosePersonDialog,
    resultView,
    ChinaAreaData,
  },
  props: {
    stepForm: Object,
  },
  data() {
    return {
      type: 'register', // register 正常登记，edit 修改订单

      uploadUrl:`${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=register/evidence/files/`,
      uploadHeaders:{ 
        'Authorization': this.$store.getters.token,
        'Product-Mode': "READ",
        'Terminal-Code': "IPCHAIN2"+ this.$store.getters.terminalCode,
        'Terminal-Type': "WEB",
        'Merchant-Id': "5"
      },
      constants,
      step: 1,
      tabIdx: "tab1",
      fileList2: [],
      fileList: [],
      uploadControllers: {},  // 修改为对象存储，key为文件uid，value为对应的控制器

      // form: {
      //   subject: "",
      //   worksType: "",
      //   files: [],

      // },
      form: this.stepForm,
      rules: {
        subject: [
          { required: true, message: "请输入登记名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
          { 
            validator: (rule, value, callback) => {
              // let subjectName = this.form.subject.replace(/[\u00A0\s"`~!@#$%^&*()+=|{}':;',\[\].<>\/?~！@#￥%……&*（）——+|{}【】‘；：”“'。，、？]/g, '', '');  // 正则替换掉特殊符号              
              let subjectName = this.form.subject;
              if(this.form.files.length === 1 && subjectName != this.form.files[0].sourceName){
                callback(new Error("作品名称须与上传样本文件名称保持一致"));
              }
               // 如果是edit类型，说明是初审或者终审驳回件，直接通过验证，不需要下面的重名验证
              if (this.type === 'edit') {
                return callback();
              }
              // 异步验证示例
              queryDuplicate({subject: this.form.subject}).then(data => {
                data.data.duplicate ? callback(new Error('经查询作品名称重复')) : callback();
              }).catch(error => {
                this.isLoading = false; // 出错时也关闭loading
                console.error('验证接口出错:', error);
                // callback(); // 可以选择继续表单验证或调用callback(new Error('验证失败')) // 这里放行了表单提交！
                callback(new Error(`验证服务异常: ${error.message || '未知错误'}`)); // 拦截提交
              });
            },
            trigger: "blur"
          },
        ],
        files: [
          { required: true, message: "请上传作品", trigger: "blur" },
        ],

        province: [
          { required: true, validator: this.valiCity, trigger: "blur" },
        ],
      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  created() {
    // 从 localStorage 中加载数据
    const savedData = localStorage.getItem(`form01_${this.mid}`);
    if (savedData) {
      this.form = JSON.parse(savedData);
    }

    if(this.$route.query.type && (this.$route.query.type == 'edit')){
      // console.log('type::::',this.$route.query.type);
      this.type = this.$route.query.type
    }
    
      // 此处不需要加载存证文件以及权利人信息
    //this.loadData();
    // this.form = this.stepForm
    if(this.form.files){
      let arr = []
      for(let i=0;i<this.form.files.length;i++){
        const file = this.form.files[i];
        // 完整文件名 = sourceName + '.' + fileType
        const fullName = file.sourceName + '.' + file.fileType;
        arr.push({
          name: fullName,
          url: file.downloadUrl,
          uid: file.fileId || Date.now() + i, // 用 fileId 或生成唯一id
        })
      }
      this.fileList = arr
    }
    
  },
  watch: {
    form: {
      handler(newValue) {
        // 自动保存表单数据到 localStorage
        localStorage.setItem(`form01_${this.mid}`, JSON.stringify(newValue));
      },
      deep: true
    }
  },
  methods: {
    calAmount() {
        // console.log("calAmount evidencePaymentPrice",this.evidencePaymentPrice)
      // let amount = 0;
      // let registerConfig = this.evidencePaymentPrice.register;
      // amount = registerConfig.amount * 1;

      // this.form.orderAmount = amount;

      let amount = 0;
      let registerConfig;
      if(this.form.extra.processingTime == '1'){
        registerConfig = this.evidencePaymentPrice.register.read.d1;
      }else if(this.form.extra.processingTime == '3'){
        registerConfig = this.evidencePaymentPrice.register.read.d3;
      }else if(this.form.extra.processingTime == '5'){
        registerConfig = this.evidencePaymentPrice.register.read.d5;
      }else if(this.form.extra.processingTime == '15'){
        registerConfig = this.evidencePaymentPrice.register.read.d15;
      }
      amount = registerConfig.amount * 1;
      
      this.form.orderAmount = amount;
    },
    async onSubmit() {
      console.log("onSubmit..");
      try {
        const formBaseResult = await this.$refs["form"].validate();
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error);
        this.mixinsScrollView();
        return;
      }
      this.setTabIdx("tab2");
    },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      this.form.right = users;
    },
    valiCity(rule, value, callback) {
      if (!this.form.province) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city) {
        callback(new Error("请选择城市"));
        return;
      }
      if (!this.form.area) {
        callback(new Error("请选择区县"));
        return;
      }
      callback();
    },
    handleExceed(files, fileList) {
        this.$message.warning(`最多只能上传5个文件，当前已选择 ${fileList.length} 个`);
    },
    uploadBefore(file) {
        // 检查文件数量是否超过5个
        if (this.fileList.length >= 5) {
            this.$message.warning('最多只能上传5个文件，请先移除部分文件后再上传');
            return false;
        }
        const allowedTypes = ['.jpg','.jpeg','.gif','.bmp','.png','.doc','.docx','.xls','.xlsx','.ppt','.pptx','.pdf','.txt','.wav','.mp4','.wmv','.mp3','.psd'];
        // 检查文件格式
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(ext)) {
            this.$message.error('不支持的文件格式：' + ext);
            return false;
        }
        // 检查文件大小
        if (file.size > 100 * 1024 * 1024) {
            this.$message.error('文件大小不能超过100MB');
            return false;
        }
        // 大于10MB使用分片上传
        if (file.size > 10 * 1024 * 1024) {
            // console.log("上传文件大于10M，采用分片上传");
            setTimeout(() => this.chunkUpload(file), 0);// 延迟执行，避免阻塞UI
            return false;
        }
        // 小文件：继续普通上传
        return true;
			},
    uploadSuccess(response, file, fileList){
        console.log(arguments)
        this.$refs.uploader.clearValidate()
        this.form.files.push(response);
        this.calAmount();
    },
    handleRemove(file,fileList){
      // 中断该文件的上传（如果正在上传）
      this.abortUpload(file);
      // 1. 获取要删除的文件名
      const name = file.response ? `${file.response.sourceName}.${file.response.fileType}` : file.name;
      this.form.files = this.form.files.filter(file => {
        const fullName = file.sourceName + '.' + file.fileType;
        if (name.includes('.')) {
          return name !== fullName;  // 保留不匹配的文件，匹配的文件是删除的文件
        } else {
          return name !== file.sourceName;  // 保留不匹配的文件，匹配的文件是删除的文件
        }
      });
      // console.log(file,fileList);
      this.fileList = fileList
      // 更新价格
      this.calAmount();
    },

// 添加分片上传方法
async chunkUpload(file) {
  // 为当前文件创建独立的控制器
  const controller = new AbortController();
  this.uploadControllers[file.uid] = controller;
  // 检查是否已中断
  if (controller.signal.aborted) {
    throw new Error('上传已被中断');
  }
  // console.log('分片上传');
  try {
    // 1. 分片上传-1.获取上传ID /v1/ins/file/uploadId
    // 使用 Fetch API 上传
    const formData1 = new FormData()
    formData1.append('fileName', file.name)
    const randomPath = Math.random().toString(36).substring(2, 9)
    const uploadIdResponse = await fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadId?path=register/evidence/files/${randomPath}` , {
      method: "POST",
      body: formData1,
      headers: this.uploadHeaders,
    });
    if (!uploadIdResponse.ok) throw new Error('获取上传ID失败');
    
    const uploadIdData = await uploadIdResponse.json();
    const uploadId = uploadIdData.uploadId;
    console.log('分片上传ID:',uploadId);
    
    // 2. 分片上传
    const chunkSize = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);
    const partETags = []; // 存储每个分片的ETag，第三步需要的参数

    // 在fileList中添加文件项，并保存索引以便后续更新
    const fileItem = {
      name: `${file.name} （分片上传进度：0/${totalChunks})`,
      uid: file.uid,
      rawFile: file, // 保存原始文件对象以便标识
      status: 'uploading', // 设置上传中状态
      totalChunks: totalChunks,
      uploadedChunks: 0,
      percentage: 0 // 确保有 percentage 属性，初始为0
    };
    this.fileList.push(fileItem);

    for (let i = 0; i < totalChunks; i++) {
       // 每次循环前检查是否已中断
       if (controller.signal.aborted) {
        throw new Error('上传已被中断');
      }
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);
      const currentPartNumber = i + 1;
      // 更新进度显示
      const currentFileIndex = this.findFileIndex(file);
      if (currentFileIndex !== -1) {
        const uploadedChunks = i; // 当前已上传的分片数
        this.fileList[currentFileIndex].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList[currentFileIndex].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList[currentFileIndex].uploadedChunks = uploadedChunks;
      }
      // 参数：
      // currentPartNumber Number 是 1 当前分⽚号
      // currentPartSize Number 是 1048576// 当前分⽚⼤⼩，除了最后⼀个分⽚外，// 所有分⽚的⼤⼩都应该不⼩于5M，最后⼀个// 分⽚的⼤⼩不受限制
      // partNum Number 是 4 总分⽚⼤⼩
      // offset Number 是 0 分⽚偏移量，从零开始
      // file File 是 待分⽚⽂件
      const formData2 = new FormData();
      formData2.append('currentPartNumber', currentPartNumber);
      formData2.append('currentPartSize', chunk.size);
      formData2.append('partNum', totalChunks);
      formData2.append('offset', start); // 分片偏移量，从零开始
      formData2.append('file', chunk);
      // 等待当前分片上传完成，请求接口
      const uploadResponse = await fetch(`${process.env.VUE_APP_BASEURL}/v1/ins/file/uploadPart/${uploadId}?path=register/evidence/files/${randomPath}`, {
        method: "POST",
        body: formData2,
        headers: this.uploadHeaders,
      });
      if (!uploadResponse.ok) throw new Error(`分片 ${currentPartNumber} 上传失败`);
      // 保存分片的ETag信息（根据实际接口返回字段调整）第三步需要使用的参数
      const partResult = await uploadResponse.json();
      if (partResult.eTag) {
        partETags.push({ partNumber: currentPartNumber, eTag: partResult.eTag });
      }

      // 更新进度显示（上传完成后）
      const currentFileIndex2 = this.findFileIndex(file);
      if (currentFileIndex2 !== -1) {
        const uploadedChunks = i + 1; // 当前已上传的分片数
        this.fileList[currentFileIndex2].name = `${file.name} （分片上传进度：${uploadedChunks}/${totalChunks})`;
        this.fileList[currentFileIndex2].percentage = Math.round((uploadedChunks / totalChunks) * 100);
        this.fileList[currentFileIndex2].uploadedChunks = uploadedChunks;
      }
      // 可选：显示上传进度
      console.log(`分片 ${currentPartNumber}/${totalChunks} 上传成功`);
    }
    
    // 再次检查是否中断（可能在最后一个分片上传后中断）
    if (controller.signal.aborted) {
      throw new Error('上传已被中断');
    }

    // 3. 合并分片// 参数：(上面接口返回) : parts:{"partNumber":1,"eTag":"6969fe670861dd98566165abcbeee01a"}
    // 上传完成后，更新为完成状态
    // 3. 合并分片
    // 使用 request API 上传,因为请求头需要Signature签名
    const mergeResponse = await request('POST', '/v1', `/ins/file/merge/${uploadId}`,partETags);
    // 这里你使用了 request API，但 mergeResponse 可能不是 Response 对象，只有使用 fetch，才能
    // if (!mergeResponse.ok) {
    //   throw new Error('合并分片失败');
    // }
    // const mergeResult = await mergeResponse.json();

    // 更新为完成状态
    const currentFileIndex3 = this.findFileIndex(file);
    if (currentFileIndex3 !== -1) {
      this.fileList[currentFileIndex3].name = `${file.name}`;  // 恢复为file.name便于删除匹配
      this.fileList[currentFileIndex3].percentage = 100;
      this.fileList[currentFileIndex3].status = 'success';
    }

    // 调用成功回调
    // this.uploadSuccess(mergeResult, file, []);
    this.uploadSuccess(mergeResponse.data, file, []);

    // 清理控制器
    delete this.uploadControllers[file.uid];

  } catch (error) {
      this.$message.error('分片上传失败');
      // 更新失败状态
      const currentFileIndex4 = this.findFileIndex(file);
      if (currentFileIndex4 !== -1) {
        this.fileList[currentFileIndex4].name = `${file.name} （上传失败）`;
        this.fileList[currentFileIndex4].percentage = 0;
        this.fileList[currentFileIndex4].status = 'fail';
      }
      this.fileList = [];
      // 清理控制器
      delete this.uploadControllers[file.uid];
  }
},
// 添加辅助方法：根据文件对象查找在fileList中的索引
findFileIndex(file) {
  return this.fileList.findIndex(item => item.rawFile === file );
},
// 添加中断上传的独立方法
abortUpload(file) {
  const fileUid = file.uid || file.rawFile?.uid;
  if (fileUid && this.uploadControllers[fileUid]) {
    console.log(`中断文件 ${file.name} 的上传`);
    this.uploadControllers[fileUid].abort();
    // 清理控制器
    delete this.uploadControllers[fileUid];
    // 更新文件状态
    const fileIndex = this.findFileIndex(file);
    if (fileIndex !== -1) {
      this.fileList[fileIndex].name = `${file.name} （已中断）`;
      this.fileList[fileIndex].status = 'fail';
      this.fileList[fileIndex].percentage = 0;
    }
    return true;
  }
  return false;
},

    // 选择办理时限
    changeProcessingTime(value){
      this.form.extra.processingTime = value;
      // 更新价格
      this.calAmount();
    },

    changePaymode(value){
      // console.log(value);
      this.form.paymode = value;
    },

    prev(){
        this.$emit('getnext',3)
    },
    async next(){
        try {
          const formBaseResult = await this.$refs["form"].validate();
          // 检查VIP支付次数
          if (this.form.paymode === 'vip') {
              const vip = this.vipInfo || {};
              const times = {
                  '15': vip.detectCount || 0,
                  '5': vip.registerCount || 0,
                  '3': vip.existCount || 0,
                  '1': vip.obtainCount || 0
              };
              const availableCount = vip.vipType === 'C' 
                  ? times[this.form.extra.processingTime] || 0
                  : vip.registerCount || 0;
              
              if (availableCount <= 0) {
                  this.$message.warning('当前会员权益支付次数为0');
                  return;
              }
          }
        } catch (error) {
          // 有错误,定位到错误
          // eslint-disable-next-line
          console.error(error);
          this.mixinsScrollView();
          return;
        }
        this.$emit('getnext',5,this.form)
    },

  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  min-height: 800px;
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
}
.ownershipRow {
  margin-bottom: 0;
}
.ownershipWrap {
  position: relative;
  padding-top: 40px;
  /deep/ .el-radio-group {
    position: absolute;
    width: 200%;
    left: 0;
    top: 11px;
  }
  .tips {
    margin-top: 0;
    .red {
      color: #ff4d4f;
      vertical-align: middle;
    }
  }
}
// .tips {
//   margin-top: 20px;
// }
.tips {
  // position: initial;
  position: absolute;
    width: 384px;
    right: -410px;
    top: 0;
}
.signatureName {
  .el-select,
  .el-input {
    width: calc(110% / 2.4);
  }
  .el-select {
    margin-right: calc(20% / 2.4);
  }
}
.Uploader2 {
  font-size: 14px;
  height: 100%;
  text-align: center;
  background: #f9fafc;
  border-radius: 4px;
  border: 1px solid #c0ccda;
}
/deep/ .submitRow .el-form-item__content {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MainStepsForm .submitRow button {
  width: 46% !important;
}

.stepTitle{
  width: 100%;
  margin: 50px 0 100px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stepTitle li {
  padding: 0 10px;
}
.stepTitle li span{
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  border: 1px solid rgba(0, 18, 22, 0.2);
  font-size: 16px;
  color: rgba(0, 18, 22, 0.2);

}
.stepTitle li p{
  color: rgba(0, 18, 22, 0.45);
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
}
.stepTitle li.active span{
  border-color: #007DFF;
  color: #fff;
  background: #007DFF;
}
.stepTitle li.active p{
  color: #007DFF;
}
.el-radio-group{
  line-height: 40px;
}

// 适配移动端
@media screen and (max-width: 991px){
  /deep/ .el-form-item__content{margin-left: 0!important;display: inline-block;width: 100%;}
  /deep/ .el-form-item__label{width: auto!important;}
  .tips{position: inherit;width: 100%;margin-top: 10px;right: 0;}
}

</style>
